import React from 'react'

const Operations = () => {
  return (
    <div>Operations</div>
  )
}

export default Operations